var biomarkerKeys = {
    panels: function (patientId) { return ['patient', patientId, 'panels']; },
};
export { biomarkerKeys };
